<template>
  <div id="runBaoWrapper">
    <!-- <iframe :src="url" width="100%" height="100%" scrolling="auto"></iframe> -->
    <!-- <span class="iconfont ys-iconiconset0399"></span> -->
    <div class="topBox">
      <Select v-model="dateType" style="width: 208px; margin-right: 10px;" @on-change="handleTask">
        <Option v-for="item in toDay" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <DatePicker v-model="start_bk_date" format="yyyy-MM-dd" type="date" placeholder="请选择起始日期"
        style="width: 168px; margin-right: 12px;">
      </DatePicker>
      <DatePicker v-model="end_bk_date" format="yyyy-MM-dd" type="date" placeholder="请选择结束日期"
        style="width: 168px; margin-right: 12px;">
      </DatePicker> -->
      <DatePicker v-model="dateArray" type="daterange" placeholder="请选择日期" style="width: 230px" @on-change="handleDateChange"></DatePicker>
    </div>
    <div class="header_top">
      <div class="every">
        <div class="leftBox"><span class="iconfont ys-iconiconset0399"></span></div>
        <div class="rightBox">
          <div>
            <p>任务数量</p>
            <p>{{infoCountTotal}}</p>
          </div>
          <div>调度中心运行的任务数量</div>
        </div>
      </div>
      <div class="every">
        <div class="leftBox"><span class="iconfont ys-iconjisuanqi"></span></div>
        <div class="rightBox">
          <div>
            <p>调度次数</p>
            <p>{{triggerCountTotal}}</p>
          </div>
          <div>调度中心触发的调度次数</div>
        </div>
      </div>
      <div class="every">
        <div class="leftBox"><span class="iconfont ys-iconrow"></span></div>
        <div class="rightBox">
          <div>
            <p>执行器数量</p>
            <p>{{groupCountTotal}}</p>
          </div>
          <div>调度中心在线的执行器机器数量</div>
        </div>
      </div>
    </div>
    <div class="echartBox">
      <div style="width: 100%;overflow: hidden;display: flex;flex-wrap: nowrap;">
        <div id="echartLopp" style="width:70%;height:350px;"></div>
        <div id="echartPie" style="width:30%;height:350px;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
import moment from 'moment';
export default {
  data() {
    return {
      dateType: '04',
      toDay: [
        { value: '01', label: '今日' },
        { value: '02', label: '昨日' },
        { value: '03', label: '本月' },
        { value: '04', label: '上个月' },
        { value: '05', label: '最近一周' },
        { value: '06', label: '最近一月' },
      ],
      start_bk_date: '', //开始日期
      end_bk_date: '', //结束日期
      dateArray: [],
      triggerCountFailTotal: 0,
      triggerCountRunningTotal: 0,
      triggerCountSucTotal: 0,
      triggerDayCountFailList: [],
      triggerDayCountRunningList: [],
      triggerDayCountSucList: [],
      triggerDayList: [],
      infoCountTotal: 0,
      triggerCountTotal: 0,
      groupCountTotal: 0
    }
  },
  methods: {
    ...mapActions([
      'sa_SpringIndexView_chartInfo', // 数据
    ]),
    leiDaNewDraw() {
      let leidaEchart = this.$echarts.init(document.getElementById('echartLopp'))
      leidaEchart.clear();
      var option = {
        title: {
            text: '调度报表',
            textStyle: {
              color: '#ffffff'
            }
        },
        tooltip : {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        backgroundColor:'#2f3d57',
        legend: {
        //   data:[I18n.joblog_status_suc, I18n.joblog_status_fail, I18n.joblog_status_running]
          textStyle: {
            color: '#ffffff'
          }
        },
        toolbox: {
            feature: {
                /*saveAsImage: {}*/
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis : [
            {
              axisLabel: {
              color: '#fff'
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
                type : 'category',
                boundaryGap : false,
                data : this.triggerDayList
            }
        ],
        yAxis : [
            {
                type : 'value',
                axisLabel: {
                  color: '#fff',
                  
                },
                axisLine: {
                  lineStyle: {
                    color: '#fff'
                  }
                }
            }
        ],
        series : [
            {
                name:'失败',
                type:'line',
                stack: 'Total',
                areaStyle: {normal: {}},
                data: this.triggerDayCountFailList
            },
            {
                name:'成功',
                type:'line',
                stack: 'Total',
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
                areaStyle: {normal: {}},
                data: this.triggerDayCountSucList
            },
            {
                name:'进行中',
                type:'line',
                stack: 'Total',
                areaStyle: {normal: {}},
                data: this.triggerDayCountRunningList
            }
        ],
        color:['#00A65A', '#c23632', '#F39C12']
      };
      leidaEchart.setOption(option)
      window.addEventListener("resize", function() {
        leidaEchart.resize();
      });
    },
    echartPie() {
      let leidaEchart = this.$echarts.init(document.getElementById('echartPie'))
      leidaEchart.clear();
      var option = {
        title: {
            text: '成功比例图',
            left: 'center',
            textStyle: {
              color: '#ffffff'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        backgroundColor:'#2f3d57',
          legend: {
              orient: 'vertical',
              left: 'left',
              data: ['成功', '失败', '进行中'],
              textStyle: {
                color: '#ffffff'
              }
          },
          series: [
              {
                  type: 'pie',
                  radius: '55%',
                  center: ['50%', '60%'],
                  data: [
                    {
                      value: this.triggerCountSucTotal,
                      name: '成功'
                    },
                    {
                      value: this.triggerCountFailTotal,
                      name: '失败',
                    },
                    {
                      value: this.triggerCountRunningTotal,
                      name: '进行中'
                    }
                  ],
                  
                  color:['#00A65A', '#c23632', '#F39C12']
              }
          ]
      };
      leidaEchart.setOption(option)
      window.addEventListener("resize", function() {
        leidaEchart.resize();
      });
    },
    // 日期change
    handleDateChange() {
      this.dateType = '';
      // 调用数据
      this.sa_SpringIndexView_chartInfos();
    },
    handleTask() {
      this.test = [];
      // 调用数据
      this.sa_SpringIndexView_chartInfos();
    },
    // 数据
    async sa_SpringIndexView_chartInfos() {
      try {
        console.log(this.dateArray.length, this.dateArray)
        const parmas = {
          startDate: this.dateArray.length !== 0 && this.dateArray[0] !== '' ? moment(this.dateArray[0]).format('YYYY-MM-DD') : '',
          endDate: this.dateArray.length !== 0 && this.dateArray[0] !== '' ? moment(this.dateArray[1]).format('YYYY-MM-DD') : '',
          dateType: this.dateArray.length !== 0 && this.dateArray[0] !== '' ? '07' : this.dateType
        }
        const data = await this.sa_SpringIndexView_chartInfo(parmas);
        const {
          triggerDayCountFailList,
          triggerDayCountRunningList,
          triggerDayCountSucList,
          triggerDayList,
          infoCountTotal,
          triggerCountTotal,
          groupCountTotal
        } = data;

        this.triggerDayCountFailList = triggerDayCountFailList;
        this.triggerDayCountRunningList = triggerDayCountRunningList;
        this.triggerDayCountSucList = triggerDayCountSucList;
        this.triggerDayList = triggerDayList;

        this.infoCountTotal = infoCountTotal;
        this.triggerCountTotal = triggerCountTotal;
        this.groupCountTotal = groupCountTotal

        this.leiDaNewDraw();
        this.echartPie();
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    // 获取数据
    this.sa_SpringIndexView_chartInfos();
  }
}
</script>
<style lang="less" scoped>
#runBaoWrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px 50px;
  box-sizing: border-box;
  .header_top {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .every {
      width: 33%;
      height: 90px;
      background: #00a65a;
      border-radius: 2px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      .leftBox {
        width: 90px;
        height: 90px;
        background: rgba(0, 0, 0, .2);
        span {
          position: relative;
          top: 12px;
          left: 24px;
          font-size: 46px;
          color: #fff;
        }
      }
      .rightBox {
        width: 436px;
        height: 90px;
        div:nth-of-type(1) {
          width: 100%;
          padding: 4px 10px;
          box-sizing: border-box;
          border-bottom: 1px solid #fff;
          p {
            font-size: 14px;
            color: #fff;
            margin-bottom: 4px;
          }
          p:nth-of-type(2) {
            font-weight: 600;
          }
        }
        div:nth-of-type(2) {
          font-size: 14px;
          color: #fff;
          padding: 4px 10px;
          box-sizing: border-box;
        }
      }
    }
    .every:nth-of-type(1) {
      background: #00c0ef;
      margin-right: 20px;
    }
    .every:nth-of-type(2) {
      margin-right: 20px;
      background: #f39c12;
    }
  }
  .echartBox {
    width: 100%;
    margin-top: 30px;
    overflow: hidden;
  }
  .topBox {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>